import { render, staticRenderFns } from "./import-reviews-dialog.vue?vue&type=template&id=99d9f2a0&scoped=true&"
import script from "./import-reviews-dialog.vue?vue&type=script&lang=js&"
export * from "./import-reviews-dialog.vue?vue&type=script&lang=js&"
import style0 from "./import-reviews-dialog.vue?vue&type=style&index=0&id=99d9f2a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d9f2a0",
  null
  
)

export default component.exports